import React, { lazy } from 'react';
import { Plus } from 'lucide-react';
import { MenuItem } from '../../lib/types';
import { formatCurrency } from '../../lib/utils';
// Fallback food images by category keyword (optimized for mobile)
const FALLBACK_IMAGES: Record<string, string> = {
  margarita: 'https://images.unsplash.com/photo-1574071318508-1cdbab80d002?w=300&h=300&fit=crop&q=60',
  margherita: 'https://images.unsplash.com/photo-1574071318508-1cdbab80d002?w=300&h=300&fit=crop&q=60',
  pepperoni: 'https://images.unsplash.com/photo-1628840042765-356cda07504e?w=300&h=300&fit=crop&q=60',
  hawaiana: 'https://images.unsplash.com/photo-1565299624946-b28f40a0ae38?w=300&h=300&fit=crop&q=60',
  hawaiian: 'https://images.unsplash.com/photo-1565299624946-b28f40a0ae38?w=300&h=300&fit=crop&q=60',
  vegetariana: 'https://images.unsplash.com/photo-1513104890138-7c049485aa9c?w=300&h=300&fit=crop&q=60',
  bbq: 'https://images.unsplash.com/photo-1513104890138-7c049485aa9c?w=300&h=300&fit=crop&q=60',
  barbacoa: 'https://images.unsplash.com/photo-1513104890138-7c049485aa9c?w=300&h=300&fit=crop&q=60',
  'cuatro quesos': 'https://images.unsplash.com/photo-1573821663912-569905455b1c?w=300&h=300&fit=crop&q=60',
  '4 quesos': 'https://images.unsplash.com/photo-1573821663912-569905455b1c?w=300&h=300&fit=crop&q=60',
  suprema: 'https://images.unsplash.com/photo-1604382354936-07c5d9983bd3?w=300&h=300&fit=crop&q=60',
  supreme: 'https://images.unsplash.com/photo-1604382354936-07c5d9983bd3?w=300&h=300&fit=crop&q=60',
  carbonara: 'https://images.unsplash.com/photo-1604382354936-07c5d9983bd3?w=300&h=300&fit=crop&q=60',
  fungi: 'https://images.unsplash.com/photo-1513104890138-7c049485aa9c?w=300&h=300&fit=crop&q=60',
  hongos: 'https://images.unsplash.com/photo-1513104890138-7c049485aa9c?w=300&h=300&fit=crop&q=60',
  champiñones: 'https://images.unsplash.com/photo-1513104890138-7c049485aa9c?w=300&h=300&fit=crop&q=60',
  italiana: 'https://images.unsplash.com/photo-1574071318508-1cdbab80d002?w=300&h=300&fit=crop&q=60',
  mexicana: 'https://images.unsplash.com/photo-1565299624946-b28f40a0ae38?w=300&h=300&fit=crop&q=60',
  pollo: 'https://images.unsplash.com/photo-1604908176997-125f25cc6f3d?w=300&h=300&fit=crop&q=60',
  carne: 'https://images.unsplash.com/photo-1600891964092-4316c288032e?w=300&h=300&fit=crop&q=60',
  jamón: 'https://images.unsplash.com/photo-1565299624946-b28f40a0ae38?w=300&h=300&fit=crop&q=60',
  jamon: 'https://images.unsplash.com/photo-1565299624946-b28f40a0ae38?w=300&h=300&fit=crop&q=60',
  tocino: 'https://images.unsplash.com/photo-1628840042765-356cda07504e?w=300&h=300&fit=crop&q=60',
  bacon: 'https://images.unsplash.com/photo-1628840042765-356cda07504e?w=300&h=300&fit=crop&q=60',
  pizza: 'https://images.unsplash.com/photo-1565299624946-b28f40a0ae38?w=300&h=300&fit=crop&q=60',
  pasta: 'https://images.unsplash.com/photo-1473093295043-cdd812d0e601?w=300&h=300&fit=crop&q=60',
  lasagna: 'https://images.unsplash.com/photo-1619881589316-56c7f9e6b587?w=300&h=300&fit=crop&q=60',
  lasaña: 'https://images.unsplash.com/photo-1619881589316-56c7f9e6b587?w=300&h=300&fit=crop&q=60',
  espagueti: 'https://images.unsplash.com/photo-1516100882582-96c3a05fe590?w=300&h=300&fit=crop&q=60',
  spaghetti: 'https://images.unsplash.com/photo-1516100882582-96c3a05fe590?w=300&h=300&fit=crop&q=60',
  fettuccine: 'https://images.unsplash.com/photo-1645112411341-6c4fd215305ad?w=300&h=300&fit=crop&q=60',
  ravioli: 'https://images.unsplash.com/photo-1588013273468-315fd88ea34c?w=300&h=300&fit=crop&q=60',
  penne: 'https://images.unsplash.com/photo-1555949258-eb67b1ef0ceb?w=300&h=300&fit=crop&q=60',
  alitas: 'https://images.unsplash.com/photo-1569691899455-88464f6d3ab1?w=300&h=300&fit=crop&q=60',
  wings: 'https://images.unsplash.com/photo-1569691899455-88464f6d3ab1?w=300&h=300&fit=crop&q=60',
  palitos: 'https://images.unsplash.com/photo-1573140247632-f8fd74997d5c?w=300&h=300&fit=crop&q=60',
  breadsticks: 'https://images.unsplash.com/photo-1573140247632-f8fd74997d5c?w=300&h=300&fit=crop&q=60',
  calzone: 'https://images.unsplash.com/photo-1628840042765-356cda07504e?w=300&h=300&fit=crop&q=60',
  pan: 'https://images.unsplash.com/photo-1509440159596-0249088772ff?w=300&h=300&fit=crop&q=60',
  bread: 'https://images.unsplash.com/photo-1509440159596-0249088772ff?w=300&h=300&fit=crop&q=60',
  papas: 'https://images.unsplash.com/photo-1576107232684-1279f390859f?w=300&h=300&fit=crop&q=60',
  fries: 'https://images.unsplash.com/photo-1576107232684-1279f390859f?w=300&h=300&fit=crop&q=60',
  patatas: 'https://images.unsplash.com/photo-1576107232684-1279f390859f?w=300&h=300&fit=crop&q=60',
  'dedos de queso': 'https://images.unsplash.com/photo-1531749668029-2db88e4276c7?w=300&h=300&fit=crop&q=60',
  'cheese sticks': 'https://images.unsplash.com/photo-1531749668029-2db88e4276c7?w=300&h=300&fit=crop&q=60',
  entrada: 'https://images.unsplash.com/photo-1541014741259-de529411b96a?w=300&h=300&fit=crop&q=60',
  entradas: 'https://images.unsplash.com/photo-1541014741259-de529411b96a?w=300&h=300&fit=crop&q=60',
  ensalada: 'https://images.unsplash.com/photo-1512621776951-a57141f2eefd?w=300&h=300&fit=crop&q=60',
  nacho: 'https://images.unsplash.com/photo-1513456852971-30c0b8199d4d?w=300&h=300&fit=crop&q=60',
  nachos: 'https://images.unsplash.com/photo-1513456852971-30c0b8199d4d?w=300&h=300&fit=crop&q=60',
  sopa: 'https://images.unsplash.com/photo-1547592166-23ac45744acd?w=300&h=300&fit=crop&q=60',
  refresco: 'https://images.unsplash.com/photo-1622483767028-3f66f32aef97?w=300&h=300&fit=crop&q=60',
  soda: 'https://images.unsplash.com/photo-1622483767028-3f66f32aef97?w=300&h=300&fit=crop&q=60',
  gaseosa: 'https://images.unsplash.com/photo-1622483767028-3f66f32aef97?w=300&h=300&fit=crop&q=60',
  jugo: 'https://images.unsplash.com/photo-1600271886742-f049cd451bba?w=300&h=300&fit=crop&q=60',
  juice: 'https://images.unsplash.com/photo-1600271886742-f049cd451bba?w=300&h=300&fit=crop&q=60',
  café: 'https://images.unsplash.com/photo-1497935586351-b67a49e012bf?w=300&h=300&fit=crop&q=60',
  coffee: 'https://images.unsplash.com/photo-1497935586351-b67a49e012bf?w=300&h=300&fit=crop&q=60',
  agua: 'https://images.unsplash.com/photo-1548839140-29a749e1bc4e?w=300&h=300&fit=crop&q=60',
  cerveza: 'https://images.unsplash.com/photo-1535958636474-b021ee887b13?w=300&h=300&fit=crop&q=60',
  beer: 'https://images.unsplash.com/photo-1535958636474-b021ee887b13?w=300&h=300&fit=crop&q=60',
  limonada: 'https://images.unsplash.com/photo-1513558161293-cdaf765ed2fd?w=300&h=300&fit=crop&q=60',
  lemonade: 'https://images.unsplash.com/photo-1513558161293-cdaf765ed2fd?w=300&h=300&fit=crop&q=60',
  té: 'https://images.unsplash.com/photo-1544787219-7f47ccb76574?w=300&h=300&fit=crop&q=60',
  tea: 'https://images.unsplash.com/photo-1544787219-7f47ccb76574?w=300&h=300&fit=crop&q=60',
  milkshake: 'https://images.unsplash.com/photo-1572490122747-3968b75cc699?w=300&h=300&fit=crop&q=60',
  batido: 'https://images.unsplash.com/photo-1572490122747-3968b75cc699?w=300&h=300&fit=crop&q=60',
  malteada: 'https://images.unsplash.com/photo-1572490122747-3968b75cc699?w=300&h=300&fit=crop&q=60',
  bebida: 'https://images.unsplash.com/photo-1544145945-f90425340c7e?w=300&h=300&fit=crop&q=60',
  bebidas: 'https://images.unsplash.com/photo-1544145945-f90425340c7e?w=300&h=300&fit=crop&q=60',
  helado: 'https://images.unsplash.com/photo-1497034825429-c343d7c6a68f?w=300&h=300&fit=crop&q=60',
  'ice cream': 'https://images.unsplash.com/photo-1497034825429-c343d7c6a68f?w=300&h=300&fit=crop&q=60',
  brownie: 'https://images.unsplash.com/photo-1606313564200-e75d5e30476c?w=300&h=300&fit=crop&q=60',
  cheesecake: 'https://images.unsplash.com/photo-1533134242443-d4fd215305ad?w=300&h=300&fit=crop&q=60',
  flan: 'https://images.unsplash.com/photo-1528975604071-b4dc52a2d18c?w=300&h=300&fit=crop&q=60',
  churro: 'https://images.unsplash.com/photo-1624371414361-e670edf4898d?w=300&h=300&fit=crop&q=60',
  galleta: 'https://images.unsplash.com/photo-1499636136210-6f4ee915583e?w=300&h=300&fit=crop&q=60',
  cookie: 'https://images.unsplash.com/photo-1499636136210-6f4ee915583e?w=300&h=300&fit=crop&q=60',
  pastel: 'https://images.unsplash.com/photo-1578985545062-69928b1d9587?w=300&h=300&fit=crop&q=60',
  cake: 'https://images.unsplash.com/photo-1578985545062-69928b1d9587?w=300&h=300&fit=crop&q=60',
  torta: 'https://images.unsplash.com/photo-1578985545062-69928b1d9587?w=300&h=300&fit=crop&q=60',
  tiramisú: 'https://images.unsplash.com/photo-1571115177098-24ec42ed204d?w=300&h=300&fit=crop&q=60',
  tiramisu: 'https://images.unsplash.com/photo-1571115177098-24ec42ed204d?w=300&h=300&fit=crop&q=60',
  postre: 'https://images.unsplash.com/photo-1551024506-0bccd828d307?w=300&h=300&fit=crop&q=60',
  postres: 'https://images.unsplash.com/photo-1551024506-0bccd828d307?w=300&h=300&fit=crop&q=60',
  taco: 'https://images.unsplash.com/photo-1565299585323-38d6b0865b47?w=300&h=300&fit=crop&q=60',
  tacos: 'https://images.unsplash.com/photo-1565299585323-38d6b0865b47?w=300&h=300&fit=crop&q=60',
  burrito: 'https://images.unsplash.com/photo-1626700051175-6818013e1d4f?w=300&h=300&fit=crop&q=60',
  burritos: 'https://images.unsplash.com/photo-1626700051175-6818013e1d4f?w=300&h=300&fit=crop&q=60',
  quesadilla: 'https://images.unsplash.com/photo-1618040996337-56904b7850b9?w=300&h=300&fit=crop&q=60',
  quesadillas: 'https://images.unsplash.com/photo-1618040996337-56904b7850b9?w=300&h=300&fit=crop&q=60',
  burger: 'https://images.unsplash.com/photo-1568901346375-23c9450c58cd?w=300&h=300&fit=crop&q=60',
  hamburguesa: 'https://images.unsplash.com/photo-1568901346375-23c9450c58cd?w=300&h=300&fit=crop&q=60',
  combo: 'https://images.unsplash.com/photo-1561758033-d89a9ad46330?w=300&h=300&fit=crop&q=60',
  combos: 'https://images.unsplash.com/photo-1561758033-d89a9ad46330?w=300&h=300&fit=crop&q=60'
};
const DEFAULT_FOOD_IMAGE = 'https://images.unsplash.com/photo-1504674900247-0877df9cc836?w=300&h=300&fit=crop&q=60';
function getFallbackImage(itemName: string): string {
  const lower = itemName.toLowerCase();
  for (const [key, url] of Object.entries(FALLBACK_IMAGES)) {
    if (lower.includes(key)) return url;
  }
  return DEFAULT_FOOD_IMAGE;
}
interface MenuItemCardProps {
  item: MenuItem;
  onClick: (item: MenuItem) => void;
  primaryColor?: string;
  theme?: 'default' | 'capricho';
}
export function MenuItemCard({
  item,
  onClick,
  primaryColor,
  theme = 'default'
}: MenuItemCardProps) {
  const imageUrl = item.image_url || getFallbackImage(item.name);
  if (theme === 'capricho') {
    return <div onClick={() => onClick(item)} className="relative flex flex-col rounded-2xl overflow-hidden cursor-pointer bg-white border border-[#E8DDD0] shadow-sm hover:shadow-md shadow-[#8B5E3C]/5 active:scale-[0.98] transition-all h-full" data-id="element-1130">
        <div className="relative aspect-[4/3] w-full bg-[#F5E9DA] shrink-0" data-id="element-1131">
          <img src={imageUrl} alt={item.name} className="absolute inset-0 w-full h-full object-cover" loading="lazy" decoding="async" data-id="element-1132" />
          <div className="absolute top-2 left-2 z-10" data-id="element-1133">
            <div className="bg-[#CE1126] text-white px-2.5 py-1 rounded-full text-[10px] sm:text-xs font-black uppercase tracking-wide shadow-lg" data-id="element-1134">
              10% OFF
            </div>
          </div>
          <button className="absolute bottom-2 right-2 w-8 h-8 rounded-full flex items-center justify-center bg-[#8B5E3C] text-white z-10 active:scale-90 transition-transform shadow-md" aria-label="Agregar al pedido" onClick={e => {
          e.stopPropagation();
          onClick(item);
        }} data-id="element-1135">
            <Plus className="w-4 h-4" data-id="element-1136" />
          </button>
        </div>
        <div className="p-3 sm:p-4 flex flex-col flex-1" data-id="element-1137">
          <h3 className="font-bold text-[#3D2B1F] text-[14px] sm:text-base leading-tight line-clamp-2 mb-1" style={{
          fontFamily: "'Playfair Display', serif"
        }} data-id="element-1138">
            {item.name}
          </h3>
          {item.description && <p className="text-[11px] sm:text-xs text-[#8B7355] line-clamp-2 mb-2 flex-1" data-id="element-1139">
              {item.description}
            </p>}
          <div className="flex items-center mt-auto pt-1" data-id="element-1140">
            <span className="font-semibold text-[#C8A96A] text-sm sm:text-base" data-id="element-1141">
              {formatCurrency(item.price)}
            </span>
          </div>
        </div>
      </div>;
  }
  // ─── Default Theme: Editorial horizontal row ───
  return <div onClick={() => onClick(item)} className="group flex items-center gap-4 py-4 px-1 cursor-pointer border-b border-white/5 last:border-b-0 hover:bg-white/[0.02] transition-colors rounded-lg -mx-1" data-id="element-1142">
      {/* Text content — takes priority */}
      <div className="flex-1 min-w-0" data-id="element-1143">
        <h3 className="font-semibold text-white/90 text-[15px] leading-snug line-clamp-1 group-hover:text-white transition-colors" data-id="element-1144">
          {item.name}
        </h3>
        {item.description && <p className="text-[13px] text-white/35 line-clamp-2 mt-1 leading-relaxed" data-id="element-1145">
            {item.description}
          </p>}
        <span className="font-semibold text-sm mt-2 block" style={{
        color: primaryColor || '#F4D35E'
      }} data-id="element-1146">
          {formatCurrency(item.price)}
        </span>
      </div>

      {/* Image — compact rounded square */}
      <div className="relative w-20 h-20 sm:w-24 sm:h-24 rounded-xl overflow-hidden shrink-0 bg-[#1a1a1a]" data-id="element-1147">
        <img src={imageUrl} alt={item.name} className="absolute inset-0 w-full h-full object-cover" loading="lazy" decoding="async" data-id="element-1148" />
        <button className="absolute bottom-1.5 right-1.5 w-7 h-7 rounded-full flex items-center justify-center text-white z-10 active:scale-90 transition-transform shadow-lg" style={{
        backgroundColor: primaryColor || '#006847'
      }} aria-label="Agregar al pedido" onClick={e => {
        e.stopPropagation();
        onClick(item);
      }} data-id="element-1149">
          <Plus className="w-3.5 h-3.5" data-id="element-1150" />
        </button>
      </div>
    </div>;
}